export const onboardingRoutes = {
  app: {
    getOnboardingStatus: '/app/contractors/me/onboarding-state',
  },
};
